import React from 'react';
import HeroSection from './HeroSection';
import TextSection from './TextSection';
import ImageTextSection from './ImageTextSection';
import GallerySection from './GallerySection';
import TestimonialsSection from './TestimonialsSection';
import CTASection from './CTASection';
import CustomSection from './CustomSection';

const SectionRenderer = ({ section }) => {
  if (!section || !section.section_type) {
    return null;
  }

  const components = {
    hero: HeroSection,
    text: TextSection,
    image_text: ImageTextSection,
    gallery: GallerySection,
    testimonials: TestimonialsSection,
    cta: CTASection,
    custom: CustomSection
  };

  const SectionComponent = components[section.section_type] || TextSection;
  return <SectionComponent section={section} />;
};

export default SectionRenderer;
